import * as Papa from 'papaparse'
import moment from 'moment'
import _, { isEmpty } from 'lodash'
import api from './api'
import { backofficeUrl } from '../config'
import {
  allArrondissementName, allVillesName,
  arrondissement,
  arrondissementName, cantonnierName,
  collecteType, maitriseName,
  returnCity,
  secteurName
} from '../filters'
import state from './state'

const headers = [
  'Véhicule',
  'Agent',
  'Tournée',
  'Date',
  'Heure',
  'Ville',
  'N° Rue',
  'Rue',
  'Anomalie',
  'Anomalie - Détail',
  'Anomalie - Détail 2',
  'Commentaire',
  'Coordonnées GPS',
  'Lien photo 1',
  'Lien photo 2',
  'Lien photo 3',
  'Lien photo 4',
  'Lien photo 5',
  'Qr code',
  'Tag NFC',
]

const demandeFileHeader = [
  'Maîtrise',
  'Cantonnier',
  'Objet de la demande',
  'Heure de la demande',
  'Réponse du cantonnier',
  'Heure de la réponse du cantonnier',
  'Statut de la demande',
  'Heure de la dernière modification',
  'Commentaire de la réalisation',
  'Durée de l\'intervention',
  'QR Code',
  'TAG NFC',
  'Photo 1',
  'Photo 2',
  'Photo 3',
  'Photo 4',
  'Photo 5',
]
const collecteFileHeader = [
  'ID',
  'TYPE',
  'X',
  'Y',
  'ADDRESSE',
  'NUMERO',
  'MOYENNE',
  'SECTEUR',
  'ARRONDISSEMENT',
  'Dernnier modification',
  'Nombre de collectes',
  'Date de création',
  'Statut',
  'Date de suppression',
]
const usersFileHeades = [
  'Nom',
  'Prenom',
  'Ville',
  'Profil',
  'Arrondissement de rattachement',
  'Date de la dernière connexion',
  'Activé',
]
var dict = {
  PELLE: 'pelle',
  BALAI: 'balai',
  SACS: 'sacs',
  PRODUITS: 'produitsremanents',
  PELLEBALAYETTE: 'pellebalayette',
  PINCE: 'pince',
  CAHIER: 'cahier',
  TROUSSEPHARMACIE: 'troussePharmacie',
  TROUSSECLE: 'trousseCle',
  SUPPORTSAC: 'supportSacs',
  LINGETTE: 'lingette',
  GRATTOIR: 'grattoir',
}

export default {

  forgeCsvReporting: function (reporting) {
    console.log('Reporting => ', reporting);
    let csv = Papa.unparse({
      fields: [
        'Véhicule',
        'Agent',
        'Tournée',
        'Date',
        'Heure',
        'Ville',
        'N° Rue',
        'Rue',
        'Anomalie',
        'Anomalie Détail',
        'Anomalie Détail 2',
        'Commentaire',
        'Coordonnées',
        'Lien photo 1',
        'Lien photo 2',
        'Lien photo 3',
        'Lien photo 4',
        'Lien photo 5',
        'Qr code',
        'Tag NFC'
      ],

      data: reporting.map((item) => ({
        Véhicule: item.materiel.numero, // Remove BOM character from the value            
        Agent: item.cantonnier.nom + item.cantonnier.prenom,
        Tournée: item.secteur.nom,
        Date: item.day,
        Heure: item.createdAt,
        Ville: item.secteur.arrondissement,
        'N° Rue': item.numeroVoie,
        Rue: item.voie,
        Anomalie: item.genre,
        'Anomalie Détail': item.anomalieDetail,
        'Anomalie Détail 2': item.anomalieDetail2,
        Commentaire: item.commentaire,
        Coordonnées: item.coords.lat + item.coords.lon,
        'Lien photo 1': item.photo1,
        'Lien photo 2': item.photo2,
        'Lien photo 3': item.photo3,
        'Lien photo 4': item.photo4,
        'Lien photo 5': item.photo5,
        'Qr code': item.QrCode,
        'Tag NFC': item.tag_NFC,
      })),
      quotes: (field, value) => {
        // Only quote fields that contain commas, newlines, or double quotes            
        return (typeof value === 'string' && (value.includes(',') || value.includes('\n') || value.includes('"')));
      },
    });
    // Add BOM character to indicate UTF-8 encoding   
    const bom = '\uFEFF';
    const csvData = bom + csv;
    var blob = new Blob([csvData],
      {
        type: 'text/csv;charset=utf-8;'
      });
    var a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = `${moment().format('YYYY-MM-DD')}_export_` + state.currentVille.name + `_reporting.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  },
  forgeCsvContent: function (verification, geopassages, printHeaders, villeName, moduleAndroid = [], maitrise) {
    let verifications = []
    let negativeVerifications = []
    let debutDeSecteurFound = false
    let finDeSecteurNotFound = false
    let finDeServiceNotFound = false
    let lastGeopassage = {}
    if (verification) {
      verifications = transformVerificationIntoLines(verification, moduleAndroid)
    }
    for (let i = 0; i < verifications.length; i++) {
      if (verifications[i].value !== 'OK' && verifications[i].value !== 'PRESENT' && verifications[i].value !== 'PROPRE' && verifications[i].value !== 'NOT/ACT') {
        negativeVerifications[i] = verifications[i]
      }
    }
    negativeVerifications = negativeVerifications.filter(element => {
      if (Object.keys(element).length !== 0) {
        return true
      }
      return false
    })
    console.log(negativeVerifications)
    let verificationsAndGeopasses = [
      ...negativeVerifications,
      ...geopassages,
    ]
    console.log(verificationsAndGeopasses)
    let cantonnier = ''
    verificationsAndGeopasses = verificationsAndGeopasses
      .sort((a, b) => {
        return parseInt(a.recorded_at) - parseInt(b.recorded_at)
      })
      .map((geopassage, index) => {
        const isAnomalie = geopassage.genre === 'ANOMALIE' || geopassage.genre === 'DEPOT_SAC' || geopassage.genre === 'EVENEMENT'
        const isVerification = geopassage.genre === 'VERIFICATION'
        const hasQrCode = geopassage.evenement !== undefined && geopassage.evenement.qr_code
        const hasNFCTag = geopassage.evenement !== undefined && geopassage.evenement.nfc_tag

        let anomaliePrefix = ''
        if (isAnomalie) {
          if (geopassage.genre === 'DEPOT_SAC') {
            anomaliePrefix = 'Sac'
          } else if (geopassage.evenement.type === 'debordement_bac' || geopassage.evenement.type === 'debordement_corbeille') {
            anomaliePrefix = 'Débordement'
          } else if (geopassage.genre === 'ANOMALIE') {
            anomaliePrefix = 'Anomalie'
          } else {
            anomaliePrefix = 'Evenement'
          }
        }
        if (isVerification) {
          if (geopassage.recorded_at === 0) {
            cantonnier = geopassage.value
          }
          return {
            'Véhicule': geopassage.materiel.numero,
            'Agent': cantonnier,
            'Tournée': geopassage.secteur.nom,
            'Date': moment(geopassage.day, 'YYYY-MM-DD').format('DD / MM / YYYY'),
            'Heure': (maitrise.is_collectivity_profile === 'true') ? '' : moment(geopassage.meta.createdAt).format('HH:mm:ss'),
            'Ville': villeName,
            'N° Rue': '-',
            'Rue': '-',
            'Anomalie': 'VERIFS AVANT DEPART',
            'Anomalie - Détail': geopassage.anomalieDetail,
            'Anomalie - Détail 2': geopassage.value,
            'Commentaire': '-',
            'Coordonnées GPS': '-',
            'Lien photo 1': '-',
            'Lien photo 2': '-',
            'Lien photo 3': '-',
            'Lien photo 4': '-',
            'Lien photo 5': '-',
            'Qr code': '',
            'Tag NFC': '',
          }
        } else {
          // Vérifier si la tournée comporte un geopassage de début de secteur
          if (!moment(moment().format('YYYY-MM-DD')).isSame(moment(geopassage.day, 'YYYY-MM-DD'))) {
            if (geopassage.genre === 'DEBUT_DE_SECTEUR') {
              debutDeSecteurFound = true
            }
            // Vérifier si l'avant dernier élement correspond à une fin de secteur
            if (index === verificationsAndGeopasses.length - 2) {
              if (geopassage.genre !== 'FIN_DE_SECTEUR' && geopassage.genre !== 'FIN_DE_SERVICE' && debutDeSecteurFound) {
                finDeSecteurNotFound = true
                lastGeopassage = geopassage
              }
            }
            // Vérifier si l'avant dernier élement correspond à une fin de service
            if (index === verificationsAndGeopasses.length - 1) {
              if (geopassage.genre !== 'FIN_DE_SERVICE') {
                finDeServiceNotFound = true
                lastGeopassage = geopassage
              }
              if (geopassage.genre === 'DEBUT_DE_SECTEUR') {
                debutDeSecteurFound = true
                finDeSecteurNotFound = true
                lastGeopassage = geopassage
              }
            }
          }
          return {
            'Véhicule': geopassage.materiel.numero,
            'Agent': geopassage.cantonnier.nom + ' ' + geopassage.cantonnier.prenom,
            'Tournée': geopassage.secteur.nom,
            'Date': moment(geopassage.day, 'YYYY-MM-DD').format('DD / MM / YYYY'),
            'Heure': (!isAnomalie && maitrise.is_collectivity_profile === 'true') ? '' : moment(Number(geopassage.recorded_at)).format('HH:mm:ss'),
            'Ville': villeName,
            'N° Rue': geopassage.numeroVoie,
            'Rue': geopassage.voie,
            'Anomalie': isAnomalie ? `${anomaliePrefix} : ${geopassage.evenement.type}` : geopassage.genre,
            'Anomalie - Détail': isAnomalie ? geopassage.evenement.detail.type : '-',
            'Anomalie - Détail 2': isAnomalie ? geopassage.evenement.detail.etat : '-',
            'Commentaire': isAnomalie ? geopassage.evenement.commentaire : '-',
            'Coordonnées GPS': `${geopassage.coords.lat}N ${geopassage.coords.lon}E`,
            'Lien photo 1': (isAnomalie && geopassage.evenement.photo) ? `${window.location.origin}/#/photo/${geopassage.evenement.photo}` : '-',
            'Lien photo 2': (isAnomalie && geopassage.evenement.other_photos && geopassage.evenement.other_photos[0]) ? `${window.location.origin}/#/photo/${geopassage.evenement.other_photos[0]}` : '-',
            'Lien photo 3': (isAnomalie && geopassage.evenement.other_photos && geopassage.evenement.other_photos[1]) ? `${window.location.origin}/#/photo/${geopassage.evenement.other_photos[1]}` : '-',
            'Lien photo 4': (isAnomalie && geopassage.evenement.other_photos && geopassage.evenement.other_photos[2]) ? `${window.location.origin}/#/photo/${geopassage.evenement.other_photos[2]}` : '-',
            'Lien photo 5': (isAnomalie && geopassage.evenement.other_photos && geopassage.evenement.other_photos[3]) ? `${window.location.origin}/#/photo/${geopassage.evenement.other_photos[3]}` : '-',
            'Qr code': hasQrCode ? geopassage.evenement.qr_code : '',
            'Tag NFC': hasNFCTag ? geopassage.evenement.nfc_tag : '',
          }
        }
      })

    if (finDeSecteurNotFound || finDeServiceNotFound) {
      pushLignesFinDeTournee(finDeSecteurNotFound, finDeServiceNotFound, verificationsAndGeopasses, lastGeopassage, villeName, maitrise)
    }

    let csvContent = Papa.unparse({
      fields: headers,
      encoding: 'UTF-8', // WINDOWS-1252
      data: verificationsAndGeopasses,
      skipEmptyLines: true,
    })

    if (!printHeaders) {
      csvContent = csvContent.substring(csvContent.indexOf(getLinebreak()) + getLinebreak().length)
    }

    return csvContent
  },
  forgeLineFTE: function (geopassages) {
    let debutDeSecteurFound = false
    let finDeSecteurNotFound = false
    let finDeServiceNotFound = false
    let lastGeopassage = {}
    let allGepassages = [
      ...geopassages,
    ]
    allGepassages = allGepassages
      .sort((a, b) => {
        return parseInt(a.recorded_at) - parseInt(b.recorded_at)
      })
    allGepassages.forEach((geopassage, index) => {
      // Vérifier si la tournée comporte un geopassage de début de secteur
      if (
        !moment(moment().format('YYYY-MM-DD')).isSame(
          moment(geopassage.day, 'YYYY-MM-DD')
        )
      ) {
        if (geopassage.genre === 'DEBUT_DE_SECTEUR') {
          debutDeSecteurFound = true
        }
        // Vérifier si l'avant dernier élement correspond à une fin de secteur
        if (index === allGepassages.length - 2) {
          if (
            geopassage.genre !== 'FIN_DE_SECTEUR' &&
            geopassage.genre !== 'FIN_DE_SERVICE' &&
            debutDeSecteurFound
          ) {
            finDeSecteurNotFound = true
            lastGeopassage = geopassage
          }
        }
        // Vérifier si l'avant dernier élement correspond à une fin de service
        if (index === allGepassages.length - 1) {
          if (geopassage.genre !== 'FIN_DE_SERVICE') {
            finDeServiceNotFound = true
            lastGeopassage = geopassage
          }
          if (geopassage.genre === 'DEBUT_DE_SECTEUR') {
            debutDeSecteurFound = true
            finDeSecteurNotFound = true
            lastGeopassage = geopassage
          }
        }
      }
    })

    if (finDeSecteurNotFound || finDeServiceNotFound) {
      pushLignesFinDeTourneeFte(finDeSecteurNotFound, finDeServiceNotFound, allGepassages, lastGeopassage)
    }

    return allGepassages
  },
  forgeCsvContentFTE(geos) {
    let csvContent = Papa.unparse({
      header: true,
      encoding: 'UTF-8', // WINDOWS-1252
      data: geos,
    })
    return csvContent
  },
  // forgeDemandesCSVFile: function (demandes) {
  //   let csvContent = Papa.unparse({
  //     fields: demandeFileHeader,
  //     encoding: 'UTF-8', // WINDOWS-1252
  //     data: demandes
  //       .map((demande, index) => {
  //         let objetDemande = replaceAll(demande.commentaire_maitrise.texte, ',', '')
  //         let reponseCantonnier = demande.commentaire_cantonnier ? demande.commentaire_cantonnier.texte ? replaceAll(demande.commentaire_cantonnier.texte, ',', '') : '-' : '-'
  //         let commentaireRealisation = demande.commentaire_realisation ? demande.commentaire_realisation.texte ? replaceAll(demande.commentaire_realisation.texte, ',', '') : '-' : '-'
  //         return {
  //           'Maîtrise': demande.maitrise.nom + ' ' + demande.maitrise.prenom,
  //           'Cantonnier': demande.cantonnier.nom + ' ' + demande.cantonnier.prenom,
  //           'Objet de la demande': objetDemande,
  //           'Heure de la demande': formatDate(demande.commentaire_maitrise.sendAt),
  //           'Réponse du cantonnier': reponseCantonnier,
  //           'Heure de la réponse du cantonnier': demande.commentaire_cantonnier ? demande.commentaire_cantonnier.sendAt ? formatDate(demande.commentaire_cantonnier.sendAt) : '' : '',
  //           'Statut de la demande': demande.statut.texte,
  //           'Heure de la dernière modification': formatDate(demande.meta.modifiedAt),
  //           'Commentaire de la réalisation': commentaireRealisation,
  //           'Durée de l\'intervention': demande.commentaire_realisation ? demande.commentaire_realisation.interventionDuration ? convertDuration(demande.commentaire_realisation.interventionDuration) : '' : '',
  //           'QR Code': demande.qr_code ? demande.qr_code : '',
  //           'TAG NFC': demande.nfc_tag ? demande.nfc_tag : '',
  //           'Photo 1': demande.photos && demande.photos[0] ? `${window.location.origin}/#/photo/${demande.photos[0]}` : '',
  //           'Photo 2': demande.photos && demande.photos[1] ? `${window.location.origin}/#/photo/${demande.photos[1]}` : '',
  //           'Photo 3': demande.photos && demande.photos[2] ? `${window.location.origin}/#/photo/${demande.photos[2]}` : '',
  //           'Photo 4': demande.photos && demande.photos[3] ? `${window.location.origin}/#/photo/${demande.photos[3]}` : '',
  //           'Photo 5': demande.photos && demande.photos[4] ? `${window.location.origin}/#/photo/${demande.photos[4]}` : '',
  //         }
  //       }),
  //   })
  //
  //   return csvContent
  // },
  forgeDemandesCSVFile: function (demandes) {
    let csvContent = Papa.unparse({
      fields: demandeFileHeader,
      encoding: 'UTF-8', // WINDOWS-1252
      data: demandes
        .map((demande, index) => {
          let objetDemande = demande.objet ? replaceAll(demande.objet, ',', '') : '-'
          let reponseCantonnier = demande.commentaire ? replaceAll(demande.commentaire, ',', '') : '-'
          let commentaireRealisation = demande.commentaireRealisation ? replaceAll(demande.commentaireRealisation, ',', '') : '-'
          return {
            'Maîtrise': maitriseName(demande.maitrise_id),
            'Cantonnier': cantonnierName(demande.cantonnier_id),
            'Objet de la demande': objetDemande,
            'Heure de la demande': formatDate(demande.createdAt),
            'Réponse du cantonnier': reponseCantonnier,
            'Heure de la réponse du cantonnier': demande.acceptedAt ? formatDate(demande.acceptedAt) : '',
            'Statut de la demande': demande.statusDemande,
            'Heure de la dernière modification': formatDate(demande.updatedAt),
            'Commentaire de la réalisation': commentaireRealisation,
            'Durée de l\'intervention': demande.dureeIntervention ? formatTime(demande.dureeIntervention) : '',
            'QR Code': demande.qrCode ? demande.qrCode : '',
            'TAG NFC': demande.nfc ? demande.nfc : '',
            'Photo 1': demande.photos && demande.photos[0] ? backofficeUrl + '/photo/' + demande.photos[0].id : '',
            'Photo 2': demande.photos && demande.photos[1] ? backofficeUrl + '/photo/' + demande.photos[1].id : '',
            'Photo 3': demande.photos && demande.photos[2] ? backofficeUrl + '/photo/' + demande.photos[2].id : '',
            'Photo 4': demande.photos && demande.photos[3] ? backofficeUrl + '/photo/' + demande.photos[3].id : '',
            'Photo 5': demande.photos && demande.photos[4] ? backofficeUrl + '/photo/' + demande.photos[4].id : '',
          }
        }),
    })

    return csvContent
  },
  forgeCollectesCSVFile: function (contenants) {
    let csvContent = Papa.unparse({
      fields: collecteFileHeader,
      encoding: 'UTF-8', // WINDOWS-1252
      data: contenants
        .map((contenant, index) => {
          return {
            'ID': contenant.reference,
            'TYPE': contenant.typeContenant,
            'X': contenant.lon,
            'Y': contenant.lat,
            'ADDRESSE': contenant.adresse,
            'NUMERO': contenant.numero,
            'MOYENNE': contenant.tauxDeRemplissage,
            'SECTEUR': secteurName(contenant.secteur_id),
            'ARRONDISSEMENT': arrondissementName(contenant.arrondissement_id),
            'Dernnier modification': formatDateExport(contenant.lastModif),
            'Nombre de collectes': contenant.nombreDeCollecte ? contenant.nombreDeCollecte : 0,
            'Date de création': formatDateExport(contenant.createdAt),
            'Statut': contenant.actif,
            'Date de suppression': deletedDate(contenant.deleteDate),
          }
        }),
    })

    return csvContent
  },
  forgeUsersCSVFile: function (users) {
    let csvContent = Papa.unparse({
      fields: usersFileHeades,
      encoding: 'UTF-8', // WINDOWS-1252
      data: users
        .filter(user => user.actif === true)
        .map((user, index) => {
          return {
            'Nom': user.nom,
            'Prenom': user.prenom,
            'Ville': allVillesName(user.ville_id),
            'Profil': 'Maîtrise',
            'Arrondissement de rattachement': allArrondissementName(user.arrondissement_id),
            'Date de la dernière connexion': formatDateExport(user.lastLoginDate),
            'Activé': user.actif ? 'Oui' : 'Non',
          }
        }),
    })

    return csvContent
  },
  promptCsvDownload: function (csvContent, fte, villeName) {
    var csvData = new window.Blob([
      '\uFEFF' + csvContent, // prepend utf8's BOM fixes excel import it seems
    ], {
      type: 'text/csv;charset=WINDOWS-1252;',
    })
    console.log(csvData)
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(csvData, 'suez_anomalies.csv')
    } else {
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(csvData)
      link.setAttribute('download', `${moment().format('YYYY-MM-DD')}_export_` + villeName + `_cantonniers.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  promptCsvDownloadDemandes: function (csvContent, fte, villeName) {
    var csvData = new window.Blob([
      '\uFEFF' + csvContent, // prepend utf8's BOM fixes excel import it seems
    ], {
      type: 'text/csv;charset=WINDOWS-1252;',
    })
    console.log(csvData)
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(csvData, 'suez_anomalies.csv')
    } else {
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(csvData)
      link.setAttribute('download', `${moment().format('YYYY-MM-DD')}_export_` + villeName + `_demandes.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  promptCsvDownloadCollectes: function (csvContent, villeName) {
    var csvData = new window.Blob([
      '\uFEFF' + csvContent, // prepend utf8's BOM fixes excel import it seems
    ], {
      type: 'text/csv;charset=WINDOWS-1252;',
    })
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(csvData, 'suez_anomalies.csv')
    } else {
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(csvData)
      link.setAttribute('download', `${moment().format('YYYY-MM-DD')}_export_` + villeName + `_contenants.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },

  promptCsvDownloadUsers: function (csvContent) {
    var csvData = new window.Blob([
      '\uFEFF' + csvContent, // prepend utf8's BOM fixes excel import it seems
    ], {
      type: 'text/csv;charset=WINDOWS-1252;',
    })
    console.log(csvData)
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(csvData, 'suez_anomalies.csv')
    } else {
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(csvData)
      link.setAttribute('download', `${moment().format('YYYY-MM-DD')}_export_actif_users.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  getLinebreak,
}

function tauxDeChargeToString(tauxCharge) {
  if (tauxCharge === 1) {
    return '0%'
  } else if (tauxCharge === 2) {
    return '25%'
  } else if (tauxCharge === 3) {
    return '50%'
  } else if (tauxCharge === 4) {
    return '75%'
  } else if (tauxCharge === 5) {
    return '100%'
  }
  return '?'
}

function transformVerificationIntoLines(verification, moduleAndroid = []) {
  let verifications = []
  moduleAndroid.activity_verif_1
    .filter(verif => {
      return verif.actif
    })
  moduleAndroid.activity_verif_3
    .filter(verif => {
      return verif.actif
    })

  verifications.push({
    anomalieDetail: 'CANTONNIER',
    value: `${verification.cantonnier.nom} ${verification.cantonnier.prenom}`,
  })

  moduleAndroid.activity_verif_1.forEach(geo => {
    var valuee
    if (verification[dict[geo.nom]] === 0) {
      valuee = 'NOT/ACT'
    } else if (verification[dict[geo.nom]] === -1) {
      valuee = 'ABSENT'
    } else if (verification[dict[geo.nom]] === 1) valuee = 'PRESENT'
    verifications.push({
      anomalieDetail: geo.nom.toUpperCase(),
      value: valuee,
    })
  })
  // verif 2
  if (moduleAndroid.activity_verif_3.some(item => {
    return item.nom === 'tauxCharge'
  })) {
    verifications.push({
      anomalieDetail: 'TAUXCHARGE',
      value: tauxDeChargeToString(verification.tauxCharge),
    })
  }
  if (moduleAndroid.activity_verif_3.some(item => {
    return item.nom === 'etatPneumatique'
  })) {
    verifications.push({
      anomalieDetail: 'ETATPNEUMATIQUE',
      value: (verification.etatPneumatique === 1 ? 'OK' : 'HS'),
    })
  }
  if (moduleAndroid.activity_verif_3.some(item => {
    return item.nom === 'niveauEau'
  })) {
    verifications.push({
      anomalieDetail: 'NIVEAUEAU',
      value: tauxDeChargeToString(verification.niveauEau),
    })
  }
  if (moduleAndroid.activity_verif_3.some(item => {
    return item.nom === 'etatFeu'
  })) {
    verifications.push({
      anomalieDetail: 'ETATFEUSIGNALEMENT',
      value: (verification.etatFeuSignalement === 1 ? 'OK' : 'HS'),
    })
  }
  // statics
  verifications.push({
    anomalieDetail: 'ETATMATERIEL',
    value: (verification.etatMateriel === 1 ? 'OK' : (verification.etatMateriel === 2 ? 'DÉGRADÉ' : 'HS')),
  })
  verifications.push({
    anomalieDetail: 'PROPRETEMATERIEL',
    value: (verification.propreteMateriel === 1 ? 'PROPRE' : 'SALE'),
  })
  verifications.push({
    anomalieDetail: 'RESPONSABLE VU ?',
    value: (verification.responsableVu === 0 ? 'N/A' : (verification.responsableVu === 1 ? 'OUI' : 'NON')),
  })
  verifications.forEach(function (v, index) {
    v.recorded_at = index
    v.genre = 'VERIFICATION'
    v.materiel = verification.materiel
    v.secteur = verification.secteur
    v.day = verification.day
    v.meta = verification.meta
  })
  console.log(verifications)
  return verifications
}

function getLinebreak() {
  if (navigator.userAgent.indexOf('Windows') !== -1) {
    return '\r\n'
  }
  return '\n'
}

function formatDate(date) {
  return moment(date).format('MM/DD/YYYY HH:mm')
}

function formatDateExport(date) {
  return moment(date).format('DD/MM/YYYY HH:mm')
}

function deletedDate(date) {
  if (date === undefined || date === null) {
    return ''
  } else {
    return formatDateExport(date)
  }
}

function convertDuration(durationInMs) {
  var dms = parseInt(durationInMs, 10)
  var secNum = Math.ceil(dms / 1000)
  var hours = Math.floor(secNum / 3600)
  var minutes = Math.floor((secNum - (hours * 3600)) / 60)
  var duration = ''

  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (hours !== '00') {
    duration = hours + 'H'
  }
  if (minutes !== '00') {
    duration = duration + minutes + 'm'
  }
  if (_.includes(duration, 'NaN')) {
    return ''
  } else {
    return duration
  }
}

function replaceAll(texte, search, replacement) {
  return texte.replace(new RegExp(search, 'g'), replacement)
}

const formatTime = (seconds) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  return hours + 'H' + minutes + 'm';
};



// WEBPACK FOOTER //
// ./src/store/csv-export.js